/**
 * @since 2.0.0
 */
export var tailRec = function tailRec(startWith, f) {
  var ab = f(startWith);

  while (ab._tag === 'Left') {
    ab = f(ab.left);
  }

  return ab.right;
};